// ** Utils
import { paginateArray } from '@utility/belt'

// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'


const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// console.log(appBaseURL)
// ** START:  
export const getProdSvcCategoryListF01Data = createAsyncThunk('appProduct/getProdSvcCategoryListF01Data', async (params, thunkAPI) => {
    try {

        const state = thunkAPI.getState() 

        const { sort, sortColumn, page = 1, perPage = 10, q = '', caller = '' } = params

        // if (import.meta.env.DEV) {
        //     console.log(`Called by ${caller}`)
        // }

        let data
        let tempIsDataLoaded

        /* Note state.prodSvcCategory is defined in 
        index.js or a js file 
        calling 
        const store = useSelector(state => state.prodSvcCategory.prodSvcCategoryListF01) */
        if (!state.prodSvcCategory.prodSvcCategoryListF01.isDataLoaded) {

            const response = await fetch(`${appBaseURL}/product/get-prodsvc-category-list-f01`)
            if (!response.ok) {
                throw new Error('Fetch response error at getProdSvcCategoryListF01Data', response.statusText)
            }
            // if (import.meta.env.DEV) {
            //     console.log('API call to /Product/getProdSvcCategoryListF01')
            // }

            data = await response.json()
            tempIsDataLoaded = true
        } else {

            data = state.prodSvcCategory.prodSvcCategoryListF01.allData
            tempIsDataLoaded = state.prodSvcCategory.prodSvcCategoryListF01.isDataLoaded
        }

        // Get from cache if isDataLoaded is false:
         
        const dataAsc = [...data].sort((a, b) => { // Pass a copy [...data] only to sort()
            let aValue, bValue
        
            // Handle cases where sortColumn might specify a nested property
            if (sortColumn.includes('.')) {
                const splitColumn = sortColumn.split('.')
                aValue = a[splitColumn[0]] ? a[splitColumn[0]][splitColumn[1]] : null
                bValue = b[splitColumn[0]] ? b[splitColumn[0]][splitColumn[1]] : null
            } else {
                aValue = a[sortColumn]
                bValue = b[sortColumn]
            }
        
            // Handling nulls - nulls will sort to the end
            if (aValue === null) return 1
            if (bValue === null) return -1
            if (aValue === null && bValue === null) return 0
        
            // General comparison
            return aValue < bValue ? -1 : aValue > bValue ? 1 : 0
        })
        
        // Determine the sorting direction
        const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

        const queryLowered = q.toLowerCase()

        const filteredData = dataToFilter.filter( 
            prodSvcCategory => { 
                return ((
                // prodSvcCategory._.toLowerCase().includes(queryLowered) ||
                // prodSvcCategory._.toLowerCase().includes(queryLowered) ||
                prodSvcCategory.prodSvcCategory.toLowerCase().includes(queryLowered))
                )
            }
        )

        return {
            params,
            data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
            allData: data,
            totalPages: filteredData.length, // TODO: Doesnt work:  Math.ceil(filteredData.length / perPage) or totalPages is a misnomer
            isDataLoaded: tempIsDataLoaded,
            caller
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)  

    }

})

export const prodSvcCategoryListF01Slice = createSlice({
    name: 'prodSvcCategoryListF01Slice',
    initialState: {
        params: {},
        data: [],
        allData: [],
        total: 0,
        totalPages: 0,
        loading: false, 
        isDataLoaded: false, // Controls caching mechanism to avoid unnecessary retrieval from DB 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    reducers: {
        setIsDataLoaded: (state, action) => {
            state.isDataLoaded = action.payload
        }
    },

    extraReducers: builder => {
    builder.addCase(getProdSvcCategoryListF01Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
        // state.isDataLoaded = true is handled by async thunk's return
        state.isDataLoaded = action.payload.isDataLoaded || false // Take value from async thunk's return
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcCategoryListF01Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcCategoryListF01Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getProdSvcCategoryListF01Data as called by ${action.payload.caller}:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// ** START:  
export const getProdSvcCategoryRowF01Data = createAsyncThunk('appProduct/getProdSvcCategoryRowF01Data', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/get-prodsvc-category-row-f01?rowId=${id}`)
        if (!response.ok) {
            throw new Error('Fetch response error at getProdSvcCategoryRowF01Data', response.statusText)
        }
        const data = await response.json()  
        return data  

    } catch (error) {
        if (import.meta.env.DEV) {
            console.error('Fetch failure at getProdSvcCategoryRowF01Data try-catch:', error)
        }
        return thunkAPI.rejectWithValue(error.message)  
    }
})

export const prodSvcCategoryRowF01Slice = createSlice({
    name: 'prodSvcCategoryRowF01Slice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(getProdSvcCategoryRowF01Data.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(getProdSvcCategoryRowF01Data.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(getProdSvcCategoryRowF01Data.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Fetch failure at getProdSvcCategoryRowF01Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Update
export const updateProdSvcCategory = createAsyncThunk('appProduct/updateProdSvcCategory', async ({id, modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/update-prodsvc-category/${id}`, {
            method: 'PUT', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        // console.log(process.env.NODE_ENV)
        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const prodSvcCategoryUpdateSlice = createSlice({
    name: 'prodSvcCategoryUpdateSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(updateProdSvcCategory.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(updateProdSvcCategory.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(updateProdSvcCategory.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Update failure at updateProdSvcCategory:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Create
export const createProdSvcCategory = createAsyncThunk('appProduct/createProdSvcCategory', async ({modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/create-prodsvc-category`, {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        if (response.ok) {
            if (response.status === 204) { 
                    // Creation successful. No Content returned from endpoint
                    return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const prodSvcCategoryCreateSlice = createSlice({
    name: 'prodSvcCategoryCreateSlice',
    initialState: {
        data: null,
        fulfilled: false,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    reducers: {
        resetCreateState: (state) => {
            state.data = null
            state.fulfilled = false
            state.loading = false
            state.rejected = false
            state.error = null
            state.errActPload = null
            state.errActMsg = null
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(createProdSvcCategory.fulfilled, (state, action) => {
            state.data = action.payload
            state.fulfilled = true
            state.loading = false
            state.rejected = false
            state.error = null
            if (import.meta.env.DEV) {
                console.log(`Success at createProdSvcCategory:\n Data: ${JSON.stringify(state.data, null, 2)}`)
            }
        })
        .addCase(createProdSvcCategory.pending, (state) => {
            state.fulfilled = false
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(createProdSvcCategory.rejected, (state, action) => {
            state.fulfilled = false
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Create failure at createProdSvcCategory\:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Delete
export const deleteProdSvcCategory = createAsyncThunk('appProduct/deleteProdSvcCategory', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/delete-prodsvc-category/${id}`, {
            method: 'DELETE', 
            headers: { 
                'Content-Type': 'application/json'
                // TBI: 'Authorization': 'Bearer ' + AccessToken 
            }
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const prodSvcCategoryDeleteSlice = createSlice({
    name: 'prodSvcCategoryDeleteSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(deleteProdSvcCategory.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(deleteProdSvcCategory.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(deleteProdSvcCategory.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
        if (import.meta.env.DEV) {
            console.error(`Delete failure at deleteProdSvcCategory:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
        })
    }
})

// Used for dropdown menu:
export const getProdSvcCategoryListF02Data = createAsyncThunk('appProduct/getProdSvcCategoryListF02Data', async (params, thunkAPI) => {
    try {

        const response = await fetch(`${appBaseURL}/product/get-prodsvc-category-list-f02`)
        if (!response.ok) {
            throw new Error('Fetch response error at getProdSvcCategoryListF02Data', response.statusText)
        }

        const data = await response.json()

        return {
            params,
            data
        }

    } catch (error) {
        console.log(error.message)
        return thunkAPI.rejectWithValue(error.message)  
    }

})

export const prodSvcCategoryListF02Slice = createSlice({
    name: 'prodSvcCategoryListF02Slice',
    initialState: {
        params: {},
        data: [],
        total: 0,
        loading: false, 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    extraReducers: builder => {
    builder.addCase(getProdSvcCategoryListF02Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.loading = false
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcCategoryListF02Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcCategoryListF02Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getProdSvcCategoryListF02Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// Export actions
export const { setIsDataLoaded } = prodSvcCategoryListF01Slice.actions
export const { resetCreateState } = prodSvcCategoryCreateSlice.actions

// Combine reducers
const prodSvcCategoryReducer = combineReducers({
    prodSvcCategoryListF01: prodSvcCategoryListF01Slice.reducer,
    prodSvcCategoryListF02: prodSvcCategoryListF02Slice.reducer,
    prodSvcCategoryRowF01: prodSvcCategoryRowF01Slice.reducer,
    prodSvcCategoryCreate: prodSvcCategoryCreateSlice.reducer,
    prodSvcCategoryUpdate: prodSvcCategoryUpdateSlice.reducer,
    prodSvcCategoryDelete: prodSvcCategoryDeleteSlice.reducer
})


export default prodSvcCategoryReducer